import React, { useState } from "react";
import SaudeOcular from "../../assets/saude-ocular.jpg";
import Refracao from "../../assets/refracao.png";
import Lentes from "../../assets/lentes-de-contato.jpg";
import ContactImage from "../../assets/contact.jpg";
import IndexCTA from "./IndexCTA";
import Apresentacao from "./Apresentacao";
import Footer from "../Footer";
import { GenPost } from "state/api";
import MsgAlert from "Admin/components/MsgAlert";

function LandingPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({ nome: "", email: "", message: "" });
  const [modalContent, setModalContent] = useState({ title: "", text: "", image: "" });
  const [msg, setMsg] = useState('Alo');

  const services = [
    {
      title: 'Exame de Refração',
      text: 'O exame de refração é essencial para determinar o grau necessário para correção visual.',
      image: Refracao,
      details: `
        O exame de refração é um procedimento fundamental realizado pelo optometrista para determinar o grau necessário para correção visual por meio de óculos ou lentes de contato. Esse exame avalia condições como:
        
        - Miopia – Dificuldade em enxergar objetos distantes.
        
        - Hipermetropia – Dificuldade em enxergar objetos próximos.
        
        - Astigmatismo – Visão distorcida devido a irregularidades na córnea.
        
        - Presbiopia – Dificuldade na visão de perto, comum com o envelhecimento.

        O exame de refração é realizado com equipamentos específicos, como o autorrefrator e o foróptero, garantindo precisão na prescrição de lentes corretivas.
      `
    },
    {
      title: 'Adaptação de Lentes de Contato',
      text: 'A adaptação de lentes de contato é um serviço para quem busca uma alternativa aos óculos.',
      image: Lentes,
      details: `
        A adaptação de lentes de contato é um serviço essencial para aqueles que desejam uma alternativa aos óculos. O optometrista avalia aspectos como:
        
        - Curvatura e formato da córnea.
        
        - Tipo de lente mais adequado (gelatinosa, rígida, tóricas, multifocais, etc.).
        
        - Necessidade de lentes especiais para casos específicos, como ceratocone.

        Além disso, o profissional orienta sobre a higienização, tempo de uso e cuidados essenciais para evitar infecções e desconfortos.
      `
    },
    {
      title: 'Avaliação da Saúde Ocular',
      text: 'Avaliação completa da saúde ocular para identificar sinais precoces de problemas.',
      image: SaudeOcular,
      details: `
        Embora o optometrista não diagnostique ou trate doenças oculares, ele desempenha um papel importante na identificação de sinais precoces de problemas que podem necessitar de acompanhamento oftalmológico. Entre as condições avaliadas estão:
        
        - Olho seco – Condição caracterizada pela baixa produção ou evaporação rápida das lágrimas.
        
        - Fadiga ocular – Problema comum devido ao uso excessivo de telas digitais.
        
        - Alterações na acuidade visual – Mudanças na nitidez da visão que podem indicar a necessidade de atualização na prescrição de lentes.

        Caso o optometrista identifique sinais de patologias mais complexas, como catarata, glaucoma ou degeneração macular, o paciente será encaminhado a um oftalmologista para um diagnóstico e tratamento adequados.
      `
    }
  ];

  const openModal = (service) => {
    setModalContent(service);
    setModalOpen(true);
  };

  const handleSubmit = async () => {
    console.log(formData);
    const requiredFields = ['nome', 'email', 'message'];
    for (const field of requiredFields) {
      if (!formData[field]) {
        setMsg(`O campo "${field}" é obrigatório`);
        setTimeout(() => setMsg(null), 3000);
        return;
      }
    }

    try {
      const payload = { ...formData };
      const response = await GenPost('/nova-msg', payload);
      setMsg(response.message);
      setTimeout(() => setMsg(null), 3000);
      setFormData({ name: "", email: "", message: "" });
      
    } catch (err) {
      setMsg(err.message);
      setTimeout(() => setMsg(null), 3000);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleClickOutside = (e) => {
    if (e.target.id === "modal-container") {
      closeModal();
    }
  };

  return (
    <div className="min-h-screen w-full bg-white">
      {/* Header */}
      <header className="bg-blue-600 text-white sticky top-0 z-50">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center">
            <span className="text-2xl font-bold">HÓRUS</span>
            <span className="ml-2 text-sm">Clínica Optometrica</span>
          </div>
          
          <div className="hidden md:flex space-x-8">
            <a href="#servicos" className="hover:text-blue-300 transition no-underline text-white">Serviços</a>
            <a href="#sobre" className="hover:text-blue-300 transition no-underline text-white">Sobre Nós</a>
            <a href="#contato" className="hover:text-blue-300 transition no-underline text-white">Contato</a>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="bg-blue-50">
        <Apresentacao />
      </section>

      {/* Serviços */}
      <section id="servicos" className="py-20">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">
            Nossos Serviços
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service) => (
              <div 
                key={service.title} 
                className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition cursor-pointer"
                onClick={() => openModal(service)}
              >
                <img src={service.image} alt={service.title} className="w-full h-48 object-cover rounded-lg mb-4" />
                <h3 className="text-xl font-semibold text-blue-900 mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sobre Nós */}
      <section id="sobre" className="bg-blue-50 py-20">
        <div className="container mx-auto px-6 md:flex items-center">
          <div className="md:w-1/2 mb-8 md:mb-0 p-4">
            <h2 className="text-3xl font-bold text-blue-900 mb-6">
              Excelência em Optometria
            </h2>
            <p className="text-gray-700 mb-4">
              Na Clínica Hórus, combinamos tecnologia de última geração com profissionais 
              altamente qualificados para oferecer o melhor tratamento ocular.
            </p>
            <ul className="text-blue-700 list-disc pl-5">
              <li>Equipamentos de última geração</li>
              <li>Médicos especializados</li>
              <li>Atendimento humanizado</li>
            </ul>
          </div>
          <div className="md:w-1/2 md:pl-12">
            <img src={ContactImage} alt="Equipe da Clínica Hórus" className="h-64 w-full object-cover rounded-lg" />
          </div>
        </div>
      </section>

      {/* Contato */}
      <section id="contato" className="py-20">
        <div className="container mx-auto px-6 max-w-2xl">
          <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">
            Mande uma Mensagem
          </h2>
          
          <div className="space-y-6 bg-slate-200 relative rounded-md shadow-md p-4 opacity-70">
            <div>
              <input 
                type="text"
                name="nome"
                onChange={handleChange}  
                placeholder="Seu nome"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <input 
                type="email"
                name="email"
                onChange={handleChange} 
                placeholder="Seu e-mail"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <textarea 
                rows="4"
                name="message"
                onChange={handleChange} 
                placeholder="Sua mensagem"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>
            <button
                onClick={handleSubmit}
                className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
              >
                Enviar Mensagem
              </button>
              <MsgAlert alert={msg} />
          </div>
        </div>
      </section>
      
      <IndexCTA/>
      <Footer />

      {/* Modal */}
      {modalOpen && (
        <div 
          id="modal-container" 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={handleClickOutside}
        >
          <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 md:w-1/2 lg:w-1/3 relative">
            <button 
              className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
              onClick={closeModal}
            >
              &times;
            </button>
            <img src={modalContent.image} alt={modalContent.title} className="w-full h-48 object-cover rounded-lg mb-4" />
            <h3 className="text-xl font-semibold text-blue-900 mb-2">{modalContent.title}</h3>
            <p className="text-gray-600 whitespace-pre-line">{modalContent.details}</p>
          </div>
        </div>
      )}
      

    </div>
  );
}

export default LandingPage;